import React from 'react';
import { OverridableStyles } from '~/utils/types.ts';
import { FormControlLabel, Switch as MuiSwitch } from '@mui/material';
import { Color } from '~/theme/index.js';

export interface SwitchProps extends OverridableStyles {
  checked?: boolean;
  label?: string;
  disabled?: boolean;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
  color?: Color;
}

const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  (props, ref) => {
    const { disabled, styleOverrides, checked, label, onChange, color } = props;
    return (
      <FormControlLabel
        disabled={disabled}
        sx={styleOverrides}
        color={color}
        control={
          <MuiSwitch
            ref={ref}
            checked={!!checked}
            onChange={onChange}
            color={color}
          />
        }
        label={label}
      />
    );
  },
);

Switch.displayName = 'Switch';
export default Switch;
